import setModalFocus from '../modal';

document.addEventListener(
  'click',
  event => {
    let targetDiv = event.target;

    const quiz = targetDiv.matches('#open-quiz');
    if (
      targetDiv.matches('strong') ||
      targetDiv.matches('em') ||
      targetDiv.matches('.floating-cta-wrapper span')
    ) {
      targetDiv = event.target.offsetParent;
    }

    if (targetDiv.matches('.show-lead-form')) {
      const height = window.scrollY;
      event.preventDefault();
      document.body.classList.add('u--no-scroll');
      if (!quiz) {
        const clientID = targetDiv.dataset.clientid;
        const formModal = document.getElementById(`${clientID}-taxi-plugin-mount-point`);
        formModal.children[0].style.display = 'block';
      }
      if (quiz) {
        setModalFocus();
      }
      document.body.style.top = `-${height}px`;
    }

    if (event.target.parentElement.classList.value === 'show-lead-form--paragraphModal') {
      targetDiv = event.target.parentElement;
    }

    if (targetDiv.classList.contains('show-lead-form--paragraphModal')) {
      // if inline text is linked to a form trigger the floating CTA form
      // If no sidebar trigger the main form

      let formModal;

      if (document.querySelector(`.floating-cta-wrapper`)) {
        formModal = document.querySelector(
          `.floating-cta-wrapper .taxi_forms_widget.taxi_forms_widget_modal.modal-overlay`,
        );
      } else {
        formModal = document.querySelector(
          `.taxi_forms_widget.taxi_forms_widget_modal.modal-overlay`,
        );
      }

      if (formModal) {
        formModal.style.display = 'block';
      }

      event.preventDefault();
    }
  },
  false,
);
